export const primaryBgColor = '#001233';
export const primaryFontColor = '#979DAC';//#9CA1AF//F7F9FE
export const primaryFgColor = '#0466C8';

export const font_h2 = 64;
export const font_h3 = 48;
export const font_h4 = 32;
export const font_h5 = 22;

export const handCursor = 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto';
export const arrowCursor = 'url(https://cdn.custom-cursor.com/db/cursor/32/Gray_cursor.png), auto';